import langs from "../i18n/langs.json";
import { languagesLocaleEnabled } from "./languagesLocaleEnabled";

export const languagesObjectsEnabled = () => {
  const localesEnabled = languagesLocaleEnabled();

  return langs.langs.filter((lang) => localesEnabled.includes(lang.locale));
};
